import React, {
    useCallback,
    useState,
    useEffect
} from 'react';
import { get as _get } from 'lodash';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';
import { E1PEHHO3PropertyDetailsComponent } from 'e1p-capability-policyjob-react';

function PropertyPage(props) {
    const { wizardData: submissionVM } = props;
    const [heatingSystemType, updateHeatingSystemType] = useState(undefined);
    const [coolingSystemType, updateCoolingSystemType] = useState(undefined);

    const generateOverrides = useCallback(() => {
        const overrideProps = {
            roofAgeMessage: {
                visible: false
            },
            partialPrefillNotification: {
                visible: false
            },
            propertyPrefillUnsuccessfulInfoMessage: {
                visible: false
            },
            covAWillBeUpdatedBasedOnReplacementCostInfoMessage: {
                visible: false
            }
        }

        return overrideProps;
    }, []);

    useEffect(() => {
        const heatingSystems = _get(submissionVM, 'lobData.homeowners_EH.coverables.construction.heatingSystems.value');

        if (heatingSystems !== undefined && heatingSystems.length > 0) {
            updateHeatingSystemType(heatingSystems[0].heatingType);
        }

        const coolingSystems = _get(submissionVM, 'lobData.homeowners_EH.coverables.construction.coolingSystems.value');

        if (coolingSystems !== undefined && coolingSystems.length > 0) {
            updateCoolingSystemType(coolingSystems[0].coolingType);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onNext = useCallback(
        () => submissionVM,
        [submissionVM]
    );


    return (
        <WizardPage
            onNext={onNext}
            shouldLink
        >
            <E1PEHHO3PropertyDetailsComponent
                transactionVM={submissionVM}
                viewOnlyMode
                heatingSystemType={heatingSystemType}
                updateHeatingSystemType={() => {}}
                coolingSystemType={coolingSystemType}
                updateCoolingSystemType={() => {}}
                parentOverrideProps={generateOverrides}
            />
        </WizardPage>
    );
}

PropertyPage.propTypes = wizardProps;
export default PropertyPage;
